import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { adjustDataModel } from "./adjustDataModel";
import { AdjustDataTable } from "./AdjustDataTable";
import { AdjustSearchBox } from "./AdjustSearchBox";
import { AdjustDrawer } from "./AdjustDrawer";
import { AdjustMonthDrawer } from "./AdjustMonthDrawer";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const AdjustDataBox = () => {

    const { selectedRowKeys, selectedData, setAdjustDrawerVisible, setAdjustMonthDrawerVisible } = adjustDataModel();

    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData[0]?.status === 1) {
                setAdjustDrawerVisible(true);
            } else {
                message.error("该条记录不可审核!");
            }
        } else {
            message.error("请选择待审核记录!");
        }
    }

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.ACC_C_VW_ADJ_AUDIT}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={onApproval}
                    >
                        审核
                    </Button>
                </YhAuth>
            </div >
        </>
    );

    return (
        <>
            <AdjustSearchBox />
            <YhBox title={action} >
                <AdjustDataTable />
            </YhBox>
            <AdjustDrawer />
            <AdjustMonthDrawer />
        </>
    )
}
